if (typeof ProductPicker !== "function") {
  class ProductPicker extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      (this.products = this.querySelectorAll(`[product-pick]`)),
        (this.primary_quick_buy = document.querySelectorAll(
          `.main-product-quick-buy`
        )),
        (this.secondary_quick_buy = document.querySelectorAll(
          `.secondary-product-quick-buy`
        ));
      this.products.forEach((el) => {
        el.addEventListener("click", (e) => {
          const block = e.target;
          const type = e.target.getAttribute("product-pick");
          const isSelected = e.target.getAttribute("selected");

          if (type == "primary") {
            if (!isSelected) {
              block.setAttribute("selected", "true");
              this.querySelector(`[product-pick="secondary"]`).removeAttribute(
                "selected"
              );
            }

            this.secondary_quick_buy.forEach((e) => {
              e.classList.remove("show");
              e.classList.add("hide");
            });

            this.primary_quick_buy.forEach((e) => {
              e.classList.remove("hide");
              e.classList.add("show");
            });
          }
          if (type == "secondary") {
            if (!isSelected) {
              block.setAttribute("selected", "true");
              this.querySelector(`[product-pick="primary"]`).removeAttribute(
                "selected"
              );
            }
            this.secondary_quick_buy.forEach((e) => {
              e.classList.remove("hide");
              e.classList.add("show");
              let variantSelector = e.querySelector(".product-form form input[name='id']")
              if (variantSelector){
                let variantId = variantSelector.getAttribute("value");
                e.querySelector(".product-price--original.pps ").setAttribute("data-variant-id", variantId);
                e.querySelector(".product-price--compare ").setAttribute("data-variant-id", variantId);
                e.querySelector(".product-price--saving.pps ").setAttribute("data-variant-id", variantId);
              }

            });

            this.primary_quick_buy.forEach((e) => {
              e.classList.remove("show");
              e.classList.add("hide");
            });
          }
        });
      });
    }
  }

  if (typeof customElements.get("product-picker") == "undefined") {
    customElements.define("product-picker", ProductPicker);
  }
}
